import { render, staticRenderFns } from "./SelectExtensions.vue?vue&type=template&id=35ce1015&"
import script from "./SelectExtensions.vue?vue&type=script&lang=js&"
export * from "./SelectExtensions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports